$(document).ready(function(){
  if($("[js-reviews-slick-int]").length > 0){ $("[js-reviews-slick-int]").slick({ autoplay: true,autoplaySpeed: 5000,pauseOnHover: true, nextArrow: '<button type="button" class="slick-next-btn">Next</button>', prevArrow: '<button type="button" class="slick-prev-btn">Prev</button>', responsive: [ {breakpoint: 2880,settings:{slidesToShow: 3,slidesToScroll: 3,infinite: true,adaptiveHeight: true,arrows: true,dots: false}}, {breakpoint: 768,settings: {slidesToShow: 1,slidesToScroll: 1,infinite: true,adaptiveHeight: true,arrows: true, centerMode: true, centerPadding: '50px'}} ] }); }
  if($('[hh-brief-testimonialSlider]').length > 0){ $('[hh-brief-testimonialSlider]').slick({ infinite: true, slidesToShow: 1, slidesToScroll: 1, arrows:true, dots:false }); }
  if($('[js-block-descriptiobvw]').length > 0){ $('[js-block-descriptiobvw]').slick({ infinite: true, slidesToShow: 1, slidesToScroll: 1, arrows:false, dots:false }); }
  if($('[js-productbriefexecution]').length > 0){ $('[js-productbriefexecution]').slick({ infinite: true, slidesToShow: 1, slidesToScroll: 1, centerMode:true, arrows:false, dots:false }); }
  if($('.ImageIconTextBlockWpMb').length > 0){ $('.ImageIconTextBlockWpMb').slick({ infinite: true, slidesToShow: 1, slidesToScroll: 1, arrows:false, dots:true }); }
  
  $(window).on('resize load',function(){
    if($(window).width() <= 768){
      $('.press-logo-content').slick({
        responsive: [
          { breakpoint: 9999, settings: "unslick" },
          { breakpoint: 768, settings: { arrows: false, dots: false, slidesToShow: 2, autoplay: true, autoplaySpeed: 1300 } },
          { breakpoint: 480, settings: { arrows: false, dots: false, slidesToShow: 2, autoplay: true, autoplaySpeed: 1300 } }
        ]
      });  
    }
  })

  if($('.LiEachCustomerWp').length > 0){
    $(document).on('click','.LiEachCustomerWp', function(e){
      e.preventDefault();
      if( $(this).hasClass('active') ){}else{
        var finder = $(this).attr('checker');var previousFinder = $('.LiEachCustomerWp.active').attr('checker');$(this).addClass('active').siblings().removeClass('active');
        $('[finder="'+finder+'"]').addClass('active').siblings().removeClass('active');$('.CustomerMainAccountWrapperEx').removeClass('currentlyactive-'+previousFinder).addClass('currentlyactive-'+finder);
        $('body').removeClass('accOpenTabs');
        $('.mobileAttribution').removeClass('active');
        $('.CustomerMainWpLeftSt').removeClass('active');
      }
    })
  }

  if($('[passwordChangeFiled]').length > 0){
    $(document).on('click','[passwordChangeFiled] span', function(s){
      s.preventDefault();
      var HtmlText = $(this).text();
      HtmlText == 'Change password' ? $(this).text('Edit password') : $(this).text('Change password')
      $(this).parents('.COntenInfoaccount').children('.account_edit_pass').toggleClass('active');
    })
  }

  if($('.mobileAttribution').length > 0){
    $(document).on('click','.mobileAttribution', function(s){
      s.preventDefault();
      $('body').toggleClass('accOpenTabs');
      $(this).toggleClass('active');
      $(this).parents('.CustomerInnerMnWpExTim').children('.CudtomerAccountDetailsMnWp').children('.CustomerMainWpLeftSt').toggleClass('active');
    }) 
  }
});